import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "progressbar-modal-comp",
    template: `
    <div class="modal-header">
        <h4 class="modal-title">Session Timeout</h4>
    </div>
    <div class="modal-body">
        You're being timed out due to inactivity. <br/>
        Please choose to stay logged in or to log off. <br/>
        Otherwise you will be logged off automatically.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="logout()">Log Off</button>
        <button type="button" class="btn btn-secondary" (click)="stayLoggedIn()">Stay Logged In <span>({{countdown + 's'}})</span></button>
    </div>
    `
})
export class ProgressBarModalComponent {
    @Input() countdown: number;

    constructor(public activeModal: NgbActiveModal) {
    }

    stayLoggedIn() {
        this.activeModal.close("stay");
    }

    logout() {
        this.activeModal.close("logout");
    }
}

